import { ReactNode } from 'react';
import { Box } from 'ui';
import { css, styled, SxProps, Theme } from '@mui/material';

interface Props {
  children: ReactNode | ReactNode[];
  sx?: SxProps<Theme>;
}

const FooterRoot = styled(Box)`
  ${({ theme }) => css`
    height: ${theme.spacing(9)};
    border-top: 1px solid ${theme.palette.common.black};
    display: flex;
    align-items: center;
    padding: 0 ${theme.spacing(4)};
  `}
`;

const PageFooter = ({ children, sx }: Props) => {
  return <FooterRoot sx={sx}>{children}</FooterRoot>;
};

export default PageFooter;
